import { useEffect, useState } from 'react';
import { initLiff, liffOpenExternal } from './lib/liff';
import { api, setSession, type Membership } from './lib/api';
import { MemberCard } from './pages/MemberCard';
import { Subscribe } from './pages/Subscribe';

type AppState =
  | { kind: 'loading' }
  | { kind: 'error'; message: string }
  | { kind: 'ready'; member: Membership };

export function App() {
  const [state, setState] = useState<AppState>({ kind: 'loading' });

  useEffect(() => {
    void boot();
  }, []);

  async function boot() {
    try {
      const { idToken } = await initLiff();
      const auth = await api.authLine(idToken);
      setSession(auth.session);
      const member = await api.membership();
      setState({ kind: 'ready', member });
    } catch (e) {
      setState({ kind: 'error', message: e instanceof Error ? e.message : String(e) });
    }
  }

  async function refresh() {
    try {
      const member = await api.membership();
      setState({ kind: 'ready', member });
    } catch (e) {
      setState({ kind: 'error', message: e instanceof Error ? e.message : String(e) });
    }
  }

  if (state.kind === 'loading') {
    return (
      <div className="app">
        <div className="brand">BAR AVALON</div>
        <div className="muted" style={{ textAlign: 'center' }}>読み込み中…</div>
      </div>
    );
  }

  if (state.kind === 'error') {
    return (
      <div className="app">
        <div className="brand">BAR AVALON</div>
        <div className="error">エラー: {state.message}</div>
      </div>
    );
  }

  const { member } = state;
  const isMembershipActive = member.status === 'active' || member.status === 'invited';

  return (
    <div className="app">
      <div className="brand">BAR AVALON</div>
      {isMembershipActive ? (
        <MemberCard member={member} onPortal={async () => {
          const r = await api.portal(window.location.href);
          liffOpenExternal(r.url);
        }} />
      ) : (
        <Subscribe member={member} onSubscribed={refresh} />
      )}
    </div>
  );
}
